export default {
  compareHub: {
    seo: {
      title: 'Comparar software logístico | Geofleet — plataforma agéntica para la ejecución',
      description:
        'Compara Geofleet con optimizadores de rutas, herramientas de última milla y plataformas enterprise de entrega. Tabla resumen y páginas dedicadas por proveedor: la plataforma logística agéntica para ejecutar de verdad.',
    },
    breadcrumb: 'Comparar',
    hero: {
      lockupPartner: 'Otras plataformas',
      eyebrow: 'Comparación de plataformas',
      h1Before: 'Compara software logístico—elige una',
      h1Highlight: 'agéntica',
      h1After: 'capa de ejecución',
      leadBefore: 'La mayoría de herramientas',
      leadEmphasis1: 'planifican o avisan',
      leadMiddle: '. Geofleet está hecha para',
      leadEmphasis2: 'ejecutar operaciones',
      leadAfter:
        ': agentes de IA en un solo centro de comando mantienen alineados a conductores, transportistas y clientes cuando cambian las condiciones, sin un parche de paneles y replanificaciones manuales.',
      ctaTable: 'Ver tabla comparativa',
      ctaTrial: 'Empezar',
      ctaDemo: 'Reservar demo',
    },
    howToLabel: 'Cómo usar esta página',
    steps: {
      overview: {
        title: 'Empieza por el panorama',
        body: 'Ve en una tabla cómo Geofleet se diferencia de rutas típicas, entregas y stacks heredados.',
      },
      vendor: {
        title: 'Profundiza en tu proveedor',
        body: 'Elige la herramienta que usas hoy: cada página es un Geofleet vs proveedor detallado.',
      },
      validate: {
        title: 'Valídalo en tu red',
        body: 'Reserva una demo para mapear hubs, transportistas y volúmenes al centro de comando y a los agentes IA.',
      },
    },
    pills: {
      command: {
        title: 'Centro de comando IA',
        sub: 'Los agentes coordinan despacho, rutas y excepciones juntos',
      },
      live: {
        title: 'Ejecución en vivo',
        sub: 'Asignación y rutas se actualizan con la red',
      },
      stack: {
        title: 'Toda la cadena de millas',
        sub: 'Hubs, portales, seguimiento y analítica en un stack',
      },
    },
    tableSection: {
      title: 'De un vistazo: ejecución agéntica frente a stacks típicos',
      description:
        'Los proveedores varían: usa la cuadrícula inferior para tu herramienta exacta. Esta tabla resume brechas habituales cuando los equipos superan soluciones puntuales y necesitan una capa de automatización en toda la red.',
      badge: 'Vista agregada honesta',
    },
    aggregateFeatures: [
      'Centro de comando IA y agentes IA',
      'Asignación automática conductores y transportistas',
      'Planificación agéntica de rutas',
      'Primera / última milla',
      'Envíos multitramo',
      'Portal del expedidor',
      'Seguimiento en tiempo real',
      'Alertas y notificaciones IA',
      'Analítica',
    ],
    aggregateGeofleetCells: [
      'Centro de comando IA con agentes IA: orquestación autónoma multietapa, gestión de excepciones y optimización continua, no un chatbot añadido ni un panel estático.',
      'Asignación automática por IA para conductores y transportistas en un solo modelo: capacidad, proximidad, SLA, coste, habilidades y condiciones en vivo actualizadas desde el centro de comando.',
      'Planificación de rutas impulsada por ML y reoptimización dinámica ante tráfico, nuevos pedidos, intentos fallidos, hubs y restricciones, sin maratones manuales de replanificación.',
      'Primera, media y última milla en una sola plataforma de automatización logística.',
      'Modela flujos multitramo y hubs complejos, no solo bucles de un conductor.',
      'Portales dedicados para expedidores y transportistas: reserva, visibilidad y colaboración.',
      'Seguimiento en vivo, ETAs predictivas y experiencia de marca alimentada por la misma capa operativa de IA.',
      'Alertas inteligentes priorizadas y notificaciones disparadas por IA para riesgo de SLA, retrasos, capacidad y excepciones.',
      'Analítica operativa e insights asistidos por IA en hubs, transportistas, rutas, conductores y SLAs.',
    ],
    aggregateCompetitorCells: [
      'La mayoría ofrece paneles, reglas o chat añadido: pocos incluyen agentes IA autónomos nativos en despacho, rutas, replanificación y excepciones en una sola torre.',
      'La asignación de conductores o tareas es habitual; un motor único que optimiza conductores y transportistas juntos ante SLAs en vivo sigue siendo poco común.',
      'Muchos optimizan rutas estáticas o lotes diarios; menos replanifican de forma continua cuando el tráfico, fallos, hubs y pedidos nuevos cambian el tablero en tiempo real.',
      'La última milla y mensajería local están bien cubiertas; primera y media milla y entregas de red suelen requerir herramientas o integraciones extra.',
      'Los bucles de un solo tramo son típicos; modelar flujos hub a hub y multitramo de primer nivel es más raro fuera de suites enterprise.',
      'Los portales de expedidor y transportista existen en algunos stacks, pero profundidad, UX y paridad con herramientas del operador varían mucho.',
      'Seguimiento y ETAs son básicos; unir la experiencia del cliente a la misma capa de IA que impulsa el despacho es menos universal.',
      'Las notificaciones suelen ser plantillas; alertas proactivas priorizadas por riesgo de SLA en toda la red exigen más madurez.',
      'KPIs de ruta o tarea son comunes; analítica unificada en hubs, transportistas, tramos y SLAs en una plataforma de automatización es más difícil de encontrar.',
    ],
    vendorsSection: {
      eyebrow: 'Páginas cara a cara',
      title: 'Encuentra tu proveedor actual',
      description:
        'Cada enlace abre una comparación dedicada: fortalezas del proveedor, dónde Geofleet va más allá y cuándo encaja mejor una plataforma logística agéntica.',
      vsPrefix: 'Geofleet vs',
      alternativeSuffix: 'alternativa',
      openLink: 'Abrir comparación',
    },
    cta: {
      headline: 'Ve Geofleet en tu red',
      subtext:
        'Recorre el centro de comando IA, la asignación y el enrutamiento agéntico con tus hubs, transportistas y SLAs: no una presentación genérica.',
    },
    faqTitle: 'Preguntas frecuentes',
    faqs: [
      {
        question: '¿Qué es una plataforma logística agéntica?',
        answer:
          'Una plataforma agéntica usa agentes IA y un centro de comando para orquestar el trabajo de forma autónoma: asignación, rutas, replanificación, alertas y comunicación con el cliente reaccionan a condiciones en vivo en lugar de depender solo de reglas estáticas o clics manuales de despacho.',
      },
      {
        question: '¿Cómo se compara Geofleet con herramientas de optimización de rutas?',
        answer:
          'Los optimizadores se centran en ordenar paradas. Geofleet trata el enrutamiento como parte de la ejecución completa—asignación automática entre conductores y transportistas, flujos multitramo y por hubs, portales de expedidor y transportista, seguimiento y analítica—para que los planes optimizados aguanten en operación.',
      },
      {
        question: '¿Cómo se compara Geofleet con software de última milla?',
        answer:
          'Las herramientas de última milla suelen girar en torno a tareas, conductores o reparto local. Geofleet apunta a la automatización logística de extremo a extremo, incluyendo media y primera milla cuando hace falta, ecosistemas de socios y gobierno de SLA a escala.',
      },
      {
        question: '¿Dónde veo un cara a cara con un proveedor concreto?',
        answer:
          'Baja hasta la cuadrícula de proveedores: cada tarjeta enlaza a una página Geofleet vs proveedor con detalle a nivel de capacidades y tradeoffs honestos.',
      },
      {
        question: '¿Debo pedir una demo para comparar opciones?',
        answer:
          'Sí. Las demos son la forma más rápida de mapear tus hubs, transportistas, volúmenes e integraciones al centro de comando y a los agentes IA de Geofleet.',
      },
    ],
  },
};
